async function getAllProjects(args) {
    const params = new URLSearchParams();
    const { token, paymentType, page, pageSize, streaming } = args;
    if (args) {
        if (paymentType) {
            params.append('payment_type', paymentType.toString());
        }
        if (page && (page > 1)) {
            params.append('page', page.toString());
        }
        if (pageSize && (pageSize > 0)) {
            params.append('page_size', pageSize.toString());
        }
        if (streaming !== undefined) {
            params.append('streaming', streaming);
        }
    }
    const queryString = params.toString();
    const url = process.env.REACT_APP_URL_PROJECTS + `?${queryString}`;
    try {
        const response = await fetch(url, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Authorization': token
            }
        });
        if (!response.ok) {
            console.error('Network response was not ok');
        }
        return await response.json();
    } catch (error) {
        console.error('There was a problem with your fetch operation:', error);
    }
}

async function getOneProjectFiles(args) {
    const { token, id } = args;
    const url = process.env.REACT_APP_URL_PROJECTS + `/${id}/files`;
    try {
        const response = await fetch(url, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Authorization': token
            }
        });
        if (!response.ok) {
            console.error('Network response was not ok');
        }
        return await response.json();
    } catch (error) {
        console.error('There was a problem with your fetch operation:', error);
    }
}

async function getOneProjectLinks(args) {
    const { token, id } = args;
    const url = process.env.REACT_APP_URL_PROJECTS + `/${id}/links`;
    try {
        const response = await fetch(url, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Authorization': token
            }
        });
        if (!response.ok) {
            console.error('Network response was not ok');
        }
        return await response.json();
    } catch (error) {
        console.error('There was a problem with your fetch operation:', error);
    }
}

async function cancelSubscription({ id = "", isFree = false, projectId }) {
    const params = new URLSearchParams();
    params.append('id', id.toString());
    let isFreeString = isFree ? '1' : '0';
    params.append('is_free', isFreeString.toString());
    params.append('project_id', projectId.toString());
    params.append('project_id', projectId.toString());

    const queryString = params.toString();
    const baseUrl = process.env.REACT_APP_API_BASE_URL;
    const url = `${baseUrl}/index.php?route=account/project/subscriptionsoff&${queryString}`;

    try {
        const response = await fetch(url, {
            method: 'GET',
        });

        if (!response.ok) {
            console.error('Network response was not ok');
        }

        return await response.json();
    } catch (error) {
        console.error('There was a problem with your fetch operation:', error);
        throw error;
    }
}

export {
    getAllProjects, getOneProjectFiles, getOneProjectLinks, cancelSubscription
};
